/*
    ESSArch is an open source archiving and digital preservation system

    ESSArch
    Copyright (C) 2005-2019 ES Solutions AB

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program. If not, see <https://www.gnu.org/licenses/>.

    Contact information:
    Web - http://www.essolutions.se
    Email - essarch@essolutions.se
*/

export default class PrepareDipModalInstanceCtrl {
  constructor($uibModalInstance, data, $http, appConfig, $q, IP) {
    const $ctrl = this;
    if (data) {
      $ctrl.data = data;
    }

    $ctrl.prepareDip = function () {
      $ctrl.preparing = true;
      let promises = [];
      $ctrl.data.ips.forEach((ip) => {
        promises.push(
          IP.prepareDip({id: ip.id}).$promise.then(function (response) {
            return response;
          })
        );
      });
      $q.all(promises).then((responses) => {
        $ctrl.preparing = false;
        $uibModalInstance.close();
      });
    };
    $ctrl.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }
}
